import { render } from "./Mural.vue?vue&type=template&id=34b42e8b&scoped=true&bindings={\"listaDeDepoimentos\":\"setup\"}"
import script from "./Mural.vue?vue&type=script&lang=js"
export * from "./Mural.vue?vue&type=script&lang=js"

import "./Mural.vue?vue&type=style&index=0&id=34b42e8b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-34b42e8b"

export default script